// Small bits of the topic pages that the main app needs on every page (routes and
// link labels), kept apart from the page text in seoPages.ts so the home page does
// not download it. Adding a topic page: add its path here too (seoPages.ts will not
// compile until you do).

export const CONTENT_PAGE_PATHS = [
  '/faq',
  '/vent-anonymously',
  '/talk-to-strangers',
  '/7-cups-alternative',
  '/omegle-alternative',
  '/blah-therapy-alternative',
  '/talklife-alternative',
  '/chatcha-alternative',
  '/hearme-alternative',
  '/supportiv-alternative',
  '/buddyhelp-alternative',
  '/wysa-alternative',
  '/replika-alternative',
  '/mellow-alternative',
  '/emerald-chat-alternative',
  '/whiteflag-alternative',
  '/wisdo-alternative',
  '/togetherall-alternative',
  '/alternatives',
  '/whimsical-websites',
] as const;
export type ContentPath = typeof CONTENT_PAGE_PATHS[number];

// Short labels for links between pages (footer and "Read next").
export const PAGE_LABELS: Record<string, string> = {
  '/faq': 'FAQ',
  '/vent-anonymously': 'Vent anonymously',
  '/talk-to-strangers': 'Talk to a stranger',
  '/whimsical-websites': 'Whimsical websites',
  '/7-cups-alternative': '7 Cups alternative',
  '/omegle-alternative': 'Omegle alternative',
  '/blah-therapy-alternative': 'Blah Therapy alternative',
  '/talklife-alternative': 'TalkLife alternative',
  '/chatcha-alternative': 'Chatcha alternative',
  '/hearme-alternative': 'HearMe alternative',
  '/supportiv-alternative': 'Supportiv alternative',
  '/buddyhelp-alternative': 'BuddyHelp alternative',
  '/wysa-alternative': 'Wysa alternative',
  '/replika-alternative': 'Replika alternative',
  '/mellow-alternative': 'Mellow alternative',
  '/emerald-chat-alternative': 'Emerald Chat alternative',
  '/whiteflag-alternative': 'WhiteFlag alternative',
  '/wisdo-alternative': 'Wisdo alternative',
  '/togetherall-alternative': 'Togetherall alternative',
  '/alternatives': 'Alternatives',
  '/sky-of-thoughts': 'Sky of Thoughts',
  '/let-go': 'Let Go',
  '/ask-ai': 'Ask AI',
  '/ai-companion': 'AI Companion',
  '/listener-guide': 'Listener guide',
  '/meet-again': 'Meet Again',
  '/world-mental-health-day': 'World Mental Health Day',
};
